import React from 'react'
import { GlobalContext } from '../../../services/context'

export const WithContext = Component => {
  return props => (
    <GlobalContext.Consumer>
      {value => (
        <Component
          {...props}
          dispatch={value.dispatch}
          contextState={value.state}
        />
      )}
    </GlobalContext.Consumer>
  )
}

export default WithContext
